import { Avatar } from "@mui/material";
import { recentlyDashboardPost } from "assets/data/dashboard";
import { Link } from "react-router-dom";
import { shortUserName } from "utils/helpers/shortUserName";
import { CustomComponentProps } from "utils/types/general.types";

export type UpdatedPostProps = CustomComponentProps & {
    recentdPost: recentlyDashboardPost;
};

const UpdatedPost = ({ recentdPost, className, style }: UpdatedPostProps) => {
    return (
        <Link
            to={`/post/${recentdPost.id}`}
            className={`flex justify-between w-full px-4 py-2 items-center gap-5 hover:shadow-lg hover:text-momeento-50 dark:text-white ${className}`}
            style={style}
        >
            <div className="flex justify-start items-center gap-2">
                <Link to={`/users/view/${recentdPost.id}`}>
                    <Avatar src={recentdPost.userPic} />
                </Link>
                <h3 className="text-sm">
                    {shortUserName(recentdPost.userName, 15)}
                </h3>
            </div>
            <div className="text-xs">{recentdPost.date}</div>
        </Link>
    );
};

export default UpdatedPost;
